import React from 'react'

import styled from 'styled-components'

import { style } from 'theme'

import { TestIDs } from '../../test/utils/testIds'

type Props = {
  logo?: string
}

const Banner = styled.div`
  align-items: center;
  background-color: ${style(theme => theme.colors.green)}
  color: white;
  display: flex;
  height: 44px;
  justify-content: center
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 10;
`

const BannerText = styled.span`
  color: white;
  font-weight: 500;
  margin-right: 6px;
`

const PartnerLogo = styled.img`
  height: 16px;
`

const ReferralBanner: React.SFC<Props> = ({ logo }) =>
  logo && (
    <Banner>
      <BannerText data-testid={TestIDs.PARTNER_BANNER.LOGO_TXT}>In partnership with</BannerText>
      <PartnerLogo src={logo} data-testid={TestIDs.PARTNER_BANNER.LOGO_IMG} />
    </Banner>
  )

export default ReferralBanner
